import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEnvelopeOpen = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EnvelopeOpen</title>
    <path
      d="M28.57 13.568v13.715c0 1.257-1.131 2.286-2.514 2.286H5.942c-1.383 0-2.515-1.029-2.515-2.286V13.568"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.57 13.568 17.343 5.403a2.286 2.286 0 0 0-2.688 0L3.427 13.568M28.57 13.568l-11.227 8.166a2.286 2.286 0 0 1-2.688 0L3.427 13.568"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoEnvelopeOpen;
